module.exports = __webpack_public_path__ + "21e82a243556a60cf38968be516cb970.svg";